module.exports = __webpack_public_path__ + "static/media/atelier_bebop_desktop_1.06ccbb5b.jpg";